var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTriaxle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "104px",
    height: "38px",
    viewBox: "0 0 104 38",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDE9Bicon/truck/triaxle2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.646923,9 L99,19.3531095 L99,31 L77,31 L77,9 L90.646923,9 Z",
    id: "Combined-Shape",
    stroke: "#4F7CB4",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-25",
    stroke: "#4F7CB4",
    strokeWidth: 2,
    fill: "#FFFFFF",
    cx: 92,
    cy: 33,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-29",
    stroke: "#4F7CB4",
    strokeWidth: 2,
    fill: "#FFFFFF",
    cx: 27,
    cy: 33,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-30",
    stroke: "#4F7CB4",
    strokeWidth: 2,
    fill: "#FFFFFF",
    cx: 39,
    cy: 33,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-31",
    stroke: "#4F7CB4",
    strokeWidth: 2,
    fill: "#FFFFFF",
    cx: 15,
    cy: 33,
    r: 4
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-16",
    stroke: "#4F7CB4",
    strokeWidth: 2,
    points: "72 31 50.0363872 31 47.4194842 26 6.60905503 26 4.35019265 31 0 31"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriaxle);
export default __webpack_public_path__ + "static/media/triaxle.663d86beea0e7a1df4a9deaf9eb05086.svg";
export { ForwardRef as ReactComponent };